import { render, staticRenderFns } from "./ServiceWorkOrder.vue?vue&type=template&id=52da5c78&scoped=true"
import script from "./ServiceWorkOrder.vue?vue&type=script&lang=js"
export * from "./ServiceWorkOrder.vue?vue&type=script&lang=js"
import style0 from "./ServiceWorkOrder.vue?vue&type=style&index=0&id=52da5c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da5c78",
  null
  
)

export default component.exports